import {useEffect, useState} from 'react';
import {Button, Card, Row, Table} from 'antd';
import {
    getAddressesForBuyer,
    getEmailAddressesForBuyer,
    getPhoneNumbersForBuyer,
    setAddressForBuyer, setEmailAddressForBuyer, setPhoneNumberForBuyer, setPrimaryAddressForBuyer,
    setPrimaryEmailAddressForBuyer, setPrimaryPhoneNumberForBuyer
} from "../../api/Api";
import {EmailEntryModal} from './EmailEntryModal';
import {PhoneNumberEntryModal} from "./PhoneNumberEntryModal";
import {AddressEntryModal} from "./AddressEntryModal";
import {PrimarySelectWidget} from "./PrimarySelectWidget";

export const BuyerProfile = ({buyer, refresh, onRefresh, onApiFail, props}) => {
    const [addresses, setAddresses] = useState([]);
    const [emailAddresses, setEmailAddresses] = useState([]);
    const [phoneNumbers, setPhoneNumbers] = useState([]);

    const [emOpen, setEmOpen] = useState(false);
    const [phoneOpen, setPhoneOpen] = useState(false);
    const [addressOpen, setAddressOpen] = useState(false);

    useEffect(() => {
        if (buyer === undefined) {
            return;
        }
        console.log(JSON.stringify(buyer));
        getAddressesForBuyer(buyer.id).then(adds => {
            console.log(JSON.stringify(adds));
            const keyedAdds = adds.map(a => {
                return {
                    key: `address${a.id}`,
                    ...a
                }
            })
            setAddresses(keyedAdds)
        }).catch (e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        });

        getEmailAddressesForBuyer(buyer.id).then(ems => {
            const keyedEmails = ems.map(email => {
                return {
                    key: email.id,
                    ...email
                }
            })
            setEmailAddresses(keyedEmails);
        }).catch (e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        });

        getPhoneNumbersForBuyer(buyer.id).then(pn => {
            const keyedPhoneNumbers = pn.map(phone => {
                return {
                    key: phone.id,
                    ...phone
                }
            });
            setPhoneNumbers(keyedPhoneNumbers);
        }).catch (e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        })
    }, [buyer, refresh, onApiFail])

    const setPrimaryAddress = (addressId) => () => {
        setPrimaryAddressForBuyer(buyer.id, addressId).then(r => {
            if (onRefresh) onRefresh();
        }).catch (e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        })
    }

    const setPrimaryEmailAddress = (emailId) => () => {
        setPrimaryEmailAddressForBuyer(buyer.id, emailId).then(r => {
            if (onRefresh) onRefresh();
        }).catch (e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        })
    }

    const setPrimaryPhoneNumber = (phoneId) => () => {
        setPrimaryPhoneNumberForBuyer(buyer.id, phoneId).then(r => {
            if (onRefresh) onRefresh();
        }).catch (e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        })
    }

    const columns = [
        {
            title: 'Street Address',
            dataIndex: 'streetAddress',
            key: 'streetAddress'
        },
        {
            title: 'Street Address Line 2',
            dataIndex: 'streetAddressLine2',
            key: 'streetAddressLine2',
        },
        {
            title: 'City',
            dataIndex: 'city',
            key: 'city',
        },
        {
            title: 'State',
            dataIndex: 'state',
            key: 'state',
        },
        {
            title: 'Postal',
            dataIndex: 'postalCode',
            key: 'postalCode',
        },
        {
            title: "Country",
            dataIndex: 'country',
            key: 'country'
        },
        {
            title: "Description",
            dataIndex: 'description',
            key: 'description'
        },
        {
            title: "Primary",
            dataIndex: "id",
            key: 'primary',
            render: (val, record, index) => {
                const {addressId} = buyer
                return <PrimarySelectWidget checked={addressId === val} onCheckClick={setPrimaryAddress(val)}/>
            }
        }
    ];

    const emailColumns = [
        {
            title: "Email",
            dataIndex: 'email',
            key: 'email'
        },
        {
            title: "Description",
            dataIndex: 'description',
            key: 'emailDescription'
        },
        {
            title: "Primary",
            dataIndex: "id",
            key: 'primary',
            render: (val, record, index) => {
                const {emailId} = buyer
                return <PrimarySelectWidget checked={emailId === val} onCheckClick={setPrimaryEmailAddress(val)}/>
            }
        }
    ];

    const phoneColumns = [
        {
            title: 'Phone Number',
            dataIndex: 'number',
            key: 'number'
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'phoneDescription'
        },
        {
            title: "Primary",
            dataIndex: "id",
            key: 'primary',
            render: (val, record, index) => {
                const {phoneId} = buyer
                return <PrimarySelectWidget checked={phoneId === val} onCheckClick={setPrimaryPhoneNumber(val)}/>
            }
        }
    ]

    const openEmailModal = () => {
        setEmOpen(true);
    }

    const closeEmailModal = () => {
        setEmOpen(false);

        if (onRefresh) onRefresh();
    }

    const openPhoneModal = () => {
        setPhoneOpen(true);
    }

    const closePhoneModal = () => {
        setPhoneOpen(false);
        if (onRefresh) onRefresh();
    }

    const openAddressModal = () => {
        setAddressOpen(true);
    }

    const closeAddressModal = () => {
        setAddressOpen(false);
        if (onRefresh) onRefresh();
    }

    const handleAddressOk = ({streetAddress, streetAddressLine2, city, state, country, postalCode, description}) => {
        setAddressForBuyer(buyer.id, streetAddress, streetAddressLine2, city, state, country, postalCode, description, false).then(r => {
            console.log(`set address succeeded`);
        }).catch(e => {
            console.log(`set address failed ${e}`)
        }).finally(() => {
            closeAddressModal();
        })
    }

    const handleEmOk = ({email, description}) => {
        setEmailAddressForBuyer(buyer.id, email, description, false).then(r => {
            console.log(`set email succeeded`);
        }).catch(e => {
            console.log(`set email failed ${e}`)
        }).finally(() => {
            closeEmailModal();
        });
    }

    const handlePhoneOk = ({phoneNumber, description}) => {
        setPhoneNumberForBuyer(buyer.id, phoneNumber, description, false).then(r => {
            console.log(`set phone number succeeded`);
        }).catch(e => {
            console.log(`set phone number failed ${e}`)
        }).finally(() => {
            closePhoneModal();
        });
    }

    const rowStyle={
        margin: '5px'
    }

    if (buyer === undefined) {
        return <div/>
    }

    return <div style={{textAlign:'left'}}>
        <Card size={'small'} title={<b>Profile</b>}>
            <div>{buyer.firstname} {buyer.lastname}</div>
            <div>{buyer.company}</div>
            <div>{buyer.license}</div>
        </Card>
        <Card size={'small'} title={<b>Address</b>}>
            <Table dataSource={addresses} columns={columns} pagination={false}/>
            <Row style={rowStyle}>
                <Button onClick={openAddressModal}>New Address</Button>
            </Row>
            <AddressEntryModal open={addressOpen} onClose={closeAddressModal} onOk={handleAddressOk} />
        </Card>
        <Card size={'small'} title={<b>Email</b>}>
            <Table dataSource={emailAddresses} columns={emailColumns} pagination={false} />
            <Row style={rowStyle}>
                <Button onClick={openEmailModal}>New Email</Button>
            </Row>
            <EmailEntryModal open={emOpen} onClose={closeEmailModal} onOk={handleEmOk}/>
        </Card>
        <Card size={'small'} title={<b>Phone Number</b>}>
            <Table dataSource={phoneNumbers} columns={phoneColumns} pagination={false}/>
            <Row style={rowStyle}>
                <Button onClick={openPhoneModal}>New Phone Number</Button>
            </Row>
            <PhoneNumberEntryModal open={phoneOpen} onClose={closePhoneModal} onOk={handlePhoneOk}/>
        </Card>
    </div>
}
